module.exports = __webpack_public_path__ + "img/money.1fd825f.webp";